import { client } from "venuescanner-js/services/socketClient";
import consume from "./models/consume";

const leads = ({ inboxService, states }) => {
  /**
   * @typedef {Object} lead - Object containing the associated thread models
   * @property {Object} thread - Thread data according to the inbox schema
   * @property {Object} admin_event - Admin event data according to the inbox schema
   * @property {Object} space - Space data according to the inbox schema
   * @property {Object} venue - Venue data according to the inbox schema
   * @property {Object} host - Host data according to the inbox schema
   * @property {Object} organiser - Organiser data according to the inbox schema
   */
  return {
    /** @function
     * @async
     * @name leads.fetch
     * @desc Fetch Leads
     * @memberof! module:inboxService
     * @returns {lead[]}
     */
    fetch: async function () {
      const objects = await client.sendPromise("room", {
        getLeads: {},
      });
      Object.keys(objects).forEach((modelName) => {
        objects[modelName] = consume(modelName, objects[modelName]);
      });
      return objects;
    },

    /** @function
     * @async
     * @name leads.ignore
     * @desc Ignore a lead Lead
     * @memberof! module:inboxService
     * @param {Object} options
     * @param {String} options._id - The _id of the lead
     * @param {String} options.message - A message to apply to this ignore lead
     * @param {String} options.reason - The reason for ignoring this lead
     * @returns {lead}
     */
    ignore: async function ({ _id, message, reason }) {
      return client.sendPromise("room", {
        "lead.ignore": { _id, message, reason },
      });
    },

    /** @function
     * @async
     * @name leads.accept
     * @desc Accept a lead
     * @memberof! module:inboxService
     * @param {Object} options
     * @param {String} options._id - The _id of the lead
     * @returns {lead}
     */
    accept: async function ({ _id, message }) {
      return client.sendPromise("room", {
        "lead.accept": { _id, message },
      });
    },

    /** @function
     * @async
     * @name leads.interested
     * @desc Show interest in a lead
     * @memberof! module:inboxService
     * @param {Object} options
     * @param {String} options._id - The _id of the lead
     * @param {String} options.price - The Price update for a Lead
     * @param {String} options.message - Message to the Organiser
     * @param {String} options.space - SpaceId - leave null to not change
     * @returns {lead}
     */
    interested: async function ({ _id, price, message, space }) {
      return client.sendPromise("room", {
        "lead.interested": { _id, price, message, space },
      });
    },

    /** @function
     * @async
     * @name leads.read
     * @desc Mark an array of leads as read
     * @memberof! module:inboxService
     * @param {Object} options
     * @param {Array} options._id - The _id of the lead
     */
    read: async function ({ _id }) {
      await client.send("room", {
        "lead.read": { leads: _id },
      });
    },

    /** @function
     * @async
     * @name leads.onNew
     * @memberof! module:inboxService
     * @desc Sets the listener for new lead models
     * @param callback {function} to receive {lead[]}
     */
    onNew: (callback) => {
      inboxService.listenerForNewPushedModels.lead = (lead) => {
        if (lead && lead.length) callback(lead);
      };
    },
  };
};
export default leads;
